import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { ILabelProps } from './models';
import styles from './styles.css';

export const LabelDesktop: FC<ILabelProps> = ({ labelText }) => {
    return (
        <div className={cn(styles.external, styles.label)}>
            <Text kind="primary" styler={{ margin: 0 }} view="action-primary-medium">
                {labelText}
            </Text>
        </div>
    );
};
